import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import '../../styles/WhatsAppNetworkError.scss';

/**
 * Component shown when there's a network error validating WhatsApp permissions
 */
const WhatsAppNetworkError = ({ onRetry }) => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.auth.user);

  const handleGoBack = () => {
    if (role === 'manager' || role === 'admin') {
      navigate('/manager/dashboard');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="whatsapp-network-error-container">
      <div className="network-error-content">
        <div className="error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#ffa726"/>
          </svg>
        </div>
        <h2>Connection Error</h2>
        <p>Unable to verify WhatsApp permissions. Please check your internet connection and try again.</p>
        <div className="error-actions">
          <button
            className="btn btn-primary"
            onClick={onRetry}
          >
            Try Again
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={handleGoBack}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

WhatsAppNetworkError.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default WhatsAppNetworkError;